<template>
  <div class="register-wrapper">
    <div class="loading-spinner-outer" v-if="saving">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Submitting request, please wait
        </div>
      </div>
    </div>
    <div class="page-title align-center">
      <h1>Register</h1>
      <div class="align-center mt-3">
        <p>
          Register for an account by filling out the form below.
        </p>
      </div>
      <div class="align-center mt-3">
        <p> You will be sent an email with a link to verify your email address.</p>
      </div>
      <div class="align-center mt-3">
        <p> Once your account is approved you will be sent an email letting you know you can log in.</p>
      </div>
    </div>
    <main class="box">
      <div class="box-content">
        <form action="/register" method="POST" id="registration_form">
          <input type="hidden" :value="csrfToken" name="_token">
          <div class="flex-2xs">
            <div class="half-width-2xs pr-3-2xs">
              <div class="form-group">
                <label>Which type of company are you?</label>
                <select type="text" class="form-control" name="company_type_id" v-model="registration_request.company_type_id" required>
                  <option disabled :value="null"> Please Select ... </option>
                  <option v-for="company_type in company_types" :value="company_type.id"> {{ company_type.label }} </option>
                </select>
              </div>
              <div class="form-group">
                <label>Company Name</label>
                <input type="text" name="company_name" v-model="registration_request.company_name" class="form-control" required>
              </div>
              <div class="form-group">
                <label>Your Name</label>
                <input type="text" class="form-control" name="name" v-model="registration_request.name" required>
              </div>
              <div class="form-group">
                <label>Email Address</label>
                <input type="text" class="form-control" name="email" v-model="registration_request.email" required>
              </div>
              <div class="form-group">
                <label>Phone Number</label>
                <input type="text" class="form-control" name="phone" v-model="registration_request.phone" required>
              </div>
            </div>
            <div class="half-width-2xs pl-3-2xs">
              <div class="form-group">
                <label>Address Line 1</label>
                <input type="text" class="form-control" name="address_line_1" v-model="registration_request.address_line_1" required>
              </div>
              <div class="form-group">
                <label>Address Line 2</label>
                <input type="text" class="form-control" name="address_line_2" v-model="registration_request.address_line_2">
              </div>
              <div class="form-group">
                <label>Town</label>
                <input type="text" class="form-control" name="address_town" v-model="registration_request.address_town">
              </div>
              <div class="form-group">
                <label>County</label>
                <input type="text" class="form-control" name="address_county" v-model="registration_request.address_county">
              </div>
              <div class="form-group">
                <label>Postcode</label>
                <input type="text" class="form-control" name="address_postcode" v-model="registration_request.address_postcode" required>
              </div>
            </div>
          </div>
          <template v-if="registration_request.company_type_id !== null">
            <div class="form-group">
              <div class="form-group">
                <label v-if="registration_request.company_type_id === 1">
                  Which systems are you fabricating?
                </label>
                <label v-else>
                  Which systems are you using?
                </label>
                <table class="table-epwin-systems-for-user">
                  <tr v-for="system_type in registration_request.epwin_system_types" v-show="system_type.label !== 'Spectrum'">
                    <td class="system">
                      <div class="checkbox">
                        <label>
                          <input type="checkbox"
                                 :name="`epwin_system_types[${system_type.id}][active_for_user]`"
                                 v-model="system_type.active_for_user"
                          >
                          <span class="checkbox-label">{{ system_type.label }}</span>
                        </label>
                      </div>
                    </td>
                    <td class="from_who">
                      <div class="form-group mb-0" v-show="system_type.active_for_user && registration_request.company_type_id !== 1">
                        <label>
                          Which fabricators do you buy this product from?
                        </label>
                        <input type="text"
                               class="form-control"
                               :name="`epwin_system_types[${system_type.id}][from_who]`"
                               v-model="system_type.from_who"
                        >
                      </div>
                    </td>
                  </tr>
                  <tr v-if="registration_request.company_type_id !== 1">
                    <div class="form-group mb-0">
                      <label>Who do you buy your soffits / fascias and trims from?</label>
                      <input type="text"
                             class="form-control"
                             name="soffits_facias_and_trims_from_who"
                             v-model="registration_request.soffits_facias_and_trims_from_who"
                      >
                    </div>
                  </tr>
                </table>
              </div>
            </div>
          </template>
          <div class="align-right mt-3">
            <button type="submit" class="btn-primary" @click.prevent="save()">
              Submit Registration Request
            </button>
          </div>
        </form>
      </div>
    </main>
  </div>
</template>


<script>
export default {
  props: [
    'company_types',
    'all_epwin_system_types',
  ],
  data() {
    return {
      csrfToken: document.querySelector('meta[name="csrf-token"]')
      .getAttribute('content'),
      saving: false,
      registration_request: {
        company_type_id: null,
        company_name: '',
        name: '',
        email: '',
        phone: '',
        address_line_1: '',
        address_line_2: '',
        address_town: '',
        address_county: '',
        address_postcode: '',
        epwin_system_types: [
        ],
        soffits_facias_and_trims_from_who: '',
      },
    };
  },
  mounted() {
    let systems = [];
    this.all_epwin_system_types.forEach(function(epwin_system_type){
      systems.push({
        'id': epwin_system_type.id,
        'label': epwin_system_type.label,
        'active_for_user': false,
        'from_who': '',
      });
    });
    this.registration_request.epwin_system_types = systems;
  },
  methods: {
    save() {
      this.saving = true;

      let validation_list = {
        company_type_id: this.registration_request.company_type_id,
        company_name: this.registration_request.company_name,
        name: this.registration_request.name,
        email: this.registration_request.email,
        address_line_1: this.registration_request.address_line_1,
        town: this.registration_request.address_town,
        county: this.registration_request.address_county,
        postcode: this.registration_request.address_postcode,
      };

      let validation_rules = {
        company_type_id: {
          presence: {
            allowEmpty: false,
          },
        },
        company_name: {
          presence: {
            allowEmpty: false,
          },
        },
        name: {
          presence: {
            allowEmpty: false,
          },
        },
        email: {
          presence: {
            allowEmpty: false,
          },
        },
        address_line_1: {
          presence: {
            allowEmpty: false,
          },
        },
        town: {
          presence: {
            allowEmpty: false,
          },
        },
        county: {
          presence: {
            allowEmpty: false,
          },
        },
        postcode: {
          presence: {
            allowEmpty: false,
          },
        },
      };

      const validationErrors = Validate(validation_list, validation_rules);

      if (validationErrors) {
        this.saving = false;
        Swal.fire({
          title: 'Unable to submit request',
          icon: 'error',
          html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
        });
        return;
      }

      if(this.registration_request.address_postcode.toLowerCase() === "ireland") {
        document.getElementById('registration_form').submit();
      } else {
        axios.get(`https://api.postcodes.io/postcodes/${this.registration_request.address_postcode}`).then((response) => {
          document.getElementById('registration_form').submit();
        }).catch(() => {
          this.saving = false;
          Swal.fire({
            title: 'Invalid Postcode',
            icon: 'warning',
          });
        });
      }

    },
  },
};
</script>
